type SupabaseEnv = {
  VITE_SUPABASE_URL?: string
  VITE_SUPABASE_PUBLISHABLE_KEY?: string
  VITE_SUPABASE_ANON_KEY?: string
}

export function resolveSupabaseConfig(env: SupabaseEnv): { url: string; key: string } {
  const url = env.VITE_SUPABASE_URL
  const key = env.VITE_SUPABASE_PUBLISHABLE_KEY || env.VITE_SUPABASE_ANON_KEY

  if (!url) {
    throw new Error('Missing VITE_SUPABASE_URL')
  }

  if (!key) {
    throw new Error(
      'Missing Supabase key. Set VITE_SUPABASE_PUBLISHABLE_KEY (preferred) or VITE_SUPABASE_ANON_KEY.',
    )
  }

  return { url, key }
}
